import {
  GET_LIST_HOPDONGDELETE,
  GET_LIST_HOPDONGDELETE_SUCCESS,
  GET_LIST_HOPDONGDELETE_FAILURE,
} from "../../actions/DanhSachHopDongDelete/actionTypes";

const initialState = {
  list: [],
  TongTien: 0,
  SoHopDong: 0,
  getListHopDongDeleteLoading: false,
};
const getListHopDongDelete = (state, action) => ({
  ...state,
  getListHopDongDeleteLoading: true,
});

const getListHopDongDeleteSuccess = (state, action) => {
  // console.log(action);
  return {
    ...state,
    list: action.payload.list,
    SoHopDong: action.payload.SoHopDong,
    TongTien: action.payload.TongTien,
    getListHopDongDeleteLoading: false,
  };
};

const getListHopDongDeleteFailed = (state, action) => ({
  ...state,
  getListHopDongDeleteLoading: false,
  list: [],
});
export const listHopDongDeleteReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LIST_HOPDONGDELETE:
      return getListHopDongDelete(state, action);
    case GET_LIST_HOPDONGDELETE_SUCCESS:
      // alert("tuty");
      return getListHopDongDeleteSuccess(state, action);
    case GET_LIST_HOPDONGDELETE_FAILURE:
      //alert('false')
      return getListHopDongDeleteFailed(state, action);
    default:
      return state;
  }
};

export default listHopDongDeleteReducer;
